export const LOGIN_STATE = 'login_state'
export const USER_INFO = 'user_info'
export const MESSAGE_CHANNEL = 'modal-message'
export const LANG = 'lang'
export const LOGIN_ENTRY = 'login_entry'
export const VIP_ACCOUNT = 'vip_account'
export const LOGIN_ENTRY_NORMAL = 'login'
export const LOGIN_ENTRY_VIP = 'profession'
